// src/modules/reminders/ReminderDashboard.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/Card';
import { Button } from '@/components/ui/button';
import { Bell, List, PlusCircle } from 'lucide-react';
import AboutSection from '../AboutSection';

const ReminderDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 p-4 flex flex-col gap-4">
      <AboutSection title="Reminders Dashboard" iconName="alarm-clock" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Card 1: Total Reminders */}
        <Card className="bg-white shadow rounded-2xl">
          <CardContent className="flex items-center justify-between p-4">
            <div>
              <p className="text-gray-500 text-sm">Total Reminders</p>
              <p className="text-2xl font-semibold text-blue-700">--</p>
            </div>
            <Bell className="text-blue-500" size={32} />
          </CardContent>
        </Card>

        {/* Card 2: View Reminders */}
        <Card className="bg-white shadow rounded-2xl">
          <CardContent className="flex items-center justify-between p-4">
            <div>
              <p className="text-gray-500 text-sm">View All Reminders</p>
              <Button variant="outline" onClick={() => navigate('list')}>
                <List className="mr-2" size={16} />
                Go to List
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Card 3: Create Reminder */}
        <Card className="bg-white shadow rounded-2xl">
          <CardContent className="flex items-center justify-between p-4">
            <div>
              <p className="text-gray-500 text-sm">Create New Reminder</p>
              <Button onClick={() => navigate('create')}>
                <PlusCircle className="mr-2" size={16} />
                Create
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Future: Charts, Upcoming Reminders List, Analytics, etc. */}
    </div>
  );
};

export default ReminderDashboard;